import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledProgressStepperStepLabelText } from './ProgressStepperStepLabelText.styles';

/**
 * Used by `ProgressStepperStep` to wrap a step's label text.
 *
 * @since 8.57.0
 */
export var ProgressStepperStepLabelText = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledProgressStepperStepLabelText, _extends({
    ref: forwardedRef
  }, props));
});
ProgressStepperStepLabelText.displayName = 'ProgressStepperStepLabelText';